import { supabase } from '@/integrations/supabase/client';

/**
 * Gets the current user's organization ID from their profile.
 * This is the standard way to enforce tenant isolation across all services.
 */
export const getCurrentUserOrganizationId = async (): Promise<string> => {
  const { data: { session }, error } = await supabase.auth.getSession();

  if (error || !session?.user) {
    throw new Error('User not authenticated');
  }

  const organizationId = session.user.app_metadata?.active_organization_id;
  if (!organizationId) {
    throw new Error('No active organization selected');
  }

  return organizationId;
};

/**
 * Base class for tenant-aware services.
 * Provides common organization-related functionality.
 */
export abstract class TenantAwareService {
  protected async getOrganizationId(): Promise<string> {
    return getCurrentUserOrganizationId();
  }

  /**
   * Adds organization_id to insert data
   */
  protected async withOrganization<T extends Record<string, any>>(data: T): Promise<T & { organization_id: string }> {
    const organizationId = await this.getOrganizationId();
    return { ...data, organization_id: organizationId };
  }
}